module.exports = __webpack_public_path__ + "img/li.3719ea6.svg";